import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Container: {
    marginLeft: '25px',
    backgroundColor: '#ffffff',
  },
  NotFound: {
    height: '100%',
    width: '100%',
    marginTop: '20%',
    textAlign: 'center',
  },
});
